<template>
    <div class="my-resume-requests">
        <div v-if="isLoading" class="rr-lds-grid">
            <p>Loading resume requests...</p>
        </div>

        <div v-if="!isLoading && resumeRequests.length">
            <div class="resume-requests-list">
                <div class="resume-request-card" v-for="request in resumeRequests" :key="request.id">
                    <div class="rr-card-header">
                        <h3 class="rr-product-name">{{ request.product_name || 'N/A' }}</h3>
                        <span class="rr-status-badge" :class="statusClass(request.status)">
                            {{ request.status || 'Pending' }}
                        </span>
                    </div>
                    <div class="rr-card-body">
                        <div class="rr-info-item">
                            <label>Status:</label>
                            <span>{{ request.status || 'Pending' }}</span>
                        </div>
                        <div class="rr-info-item">
                            <label>Created:</label>
                            <span>{{ localTime(request.created_at) }}</span>
                        </div>
                        <div class="rr-info-item" v-if="request.consultation_id">
                            <label>Consultation:</label>
                            <a :href="'/dashboard/consultations/' + request.consultation_id">
                                {{ request.consultation_id }}
                            </a>
                        </div>
                        <div class="rr-info-item" v-if="request.was_taking">
                            <label>Was Taking GLP-1:</label>
                            <span>Yes</span>
                        </div>
                        <div class="rr-info-item" v-if="request.strength">
                            <label>Medication/Strength:</label>
                            <span>{{ request.strength }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="resume-requests-actions">
                <div class="resume-requests-actions-right">
                    <div class="rr-pagination-controls">
                        <span v-if="page > 0" class="rr-click-effect" @click="prevPage">
                            <i class="fas fa-chevron-left"></i>Prev
                        </span>
                        <span
                            v-if="totalItems > perPage && page < totalPages - 1"
                            class="rr-click-effect"
                            @click="nextPage"
                        >
                            Next<i class="fas fa-chevron-right"></i>
                        </span>
                    </div>
                    <div class="rr-pagination-info">
                        <p>Current Page: {{ page + 1 }}</p>
                        <p>Pages: {{ totalPages }}</p>
                        <p>Items: {{ totalItems }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="!isLoading" class="rr-no-requests">
            You have no resume requests.
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { localTime, statusClass } from './resumeRequestHelpers';

export default {
    name: 'MyResumeRequests',

    data() {
        return {
            resumeRequests: [],
            page: 0,
            perPage: 10,
            totalPages: 0,
            totalItems: 0,
            isLoading: false,
        };
    },

    mounted() {
        this.load();
    },

    methods: {
        statusClass,
        localTime,

        load() {
            this.isLoading = true;

            axios
                .get('/api/v1/resume-requests/my-requests', {
                    params: { page: this.page + 1, per_page: this.perPage },
                })
                .then((response) => {
                    const payload = response && response.data;
                    const items = payload && payload.data;

                    this.resumeRequests = Array.isArray(items) ? items : [];
                    this.perPage = (payload && payload.per_page) || this.perPage;
                    this.totalItems = (payload && payload.total) || 0;
                    this.totalPages = this.totalItems ? Math.ceil(this.totalItems / this.perPage) : 0;
                })
                .catch(() => {
                    this.resumeRequests = [];
                    this.totalPages = 0;
                    this.totalItems = 0;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        nextPage() {
            this.page += 1;
            this.load();
        },

        prevPage() {
            this.page -= 1;
            this.load();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/MyResumeRequests.vue